/*-----------------------------------
 * MP hayabusa Customize
 * [このファイルの役割]
 * ・プラグインの読み込み
 * ・URLによるモジュールの実行
 * ・サイト設定
 * ・URLによるCSS読み込み設定
 *-----------------------------------*/

import 'jquery.easing'
import './plugins/plugins'
import './plugins/utility'
import INIT from './modules/init'

// ページ読み込み
import HOME from './page/home'
import GOODS from './page/goods';

/*****
 * サイト設定
 */
window.siteinfo = {
  tagmanager:       'GTM-T89JK7Q',
  viewport:         'width=1200',
  adobefonts:{
    kitId: 'bfu3xxz',
    scriptTimeout: 3000,
    async: true
  },
}

/*****
 * サイト初期化
 */
INIT()

/*****
 * コンテンツごとのファイル読み込み
 */
// $.require({
//   disableCache:false,
//   '*':{
//     '/': ['/asset/css/home.min.css'],
//   },
// })
switch(location.pathname){
  // トップページ
  case '/': HOME(); break;

  // やらまいかブランド認定商品
  case '/goods/': GOODS(); break;
}
